module.exports = __webpack_public_path__ + "media/images/workflow-arrow-893e94fb6caf192a8e252e0480f2c1dd.svg";